import cep from './cep'
import cnpj from './cnpj'
import cnpjAndCpfMask from './cnpjAndCpfMask'
import cnpjInput from './cnpjInput'
import cnpjOrCpfOrInternationMask from './cnpjOrCpfOrInternationMask'
import convertBinaryToBool from './convertBinaryToBool'
import convertBoolToBinary from './convertBoolToBinary'
import convertBoolToString from './convertBoolToString'
import cpf from './cpf'
import cpfInput from './cpfInput'
import creditCards from './creditCards'
import currencyInput from './currencyInput'
import currencyOutput from './currencyOutput'
import date from './date'
import dateFromNow from './dateFromNow'
import dateTime from './dateTime'
import errorMessage from './errorMessage'
import float from './float'
import floatToMoney from './floatToMoney'
import formatByNameInFilter from './formatByNameInFilter'
import getIdFromObject from './getIdFromObject'
import hours from './hours'
import isValidEmail from './isValidEmail'
import multipleParagraphs from './multipleParagraphs'
import onlyNumbers from './onlyNumbers'
import onlyNumbersFloat from './onlyNumbersFloat'
import onlyNumbersString from './onlyNumbersString'
import percentage from './percentage'
import phone from './phone'
import regex from './regex'
import regularizeCurrency from './regularizeCurrency'
import website from './website'

const formatters = {
  cep,
  cnpj,
  cnpjAndCpfMask,
  cnpjInput,
  cnpjOrCpfOrInternationMask,
  convertBinaryToBool,
  convertBoolToBinary,
  convertBoolToString,
  cpf,
  cpfInput,
  creditCards,
  currencyInput,
  currencyOutput,
  date,
  dateFromNow,
  dateTime,
  errorMessage,
  float,
  floatToMoney,
  formatByNameInFilter,
  getIdFromObject,
  hours,
  isValidEmail,
  multipleParagraphs,
  onlyNumbers,
  onlyNumbersFloat,
  onlyNumbersString,
  percentage,
  phone,
  regex,
  regularizeCurrency,
  website,
}

export default formatters
